export default {"src":"/_next/static/media/empty-search-light.ed0e1952.svg","height":100,"width":100};